<template>
    <div class="base-input-section card-body">
        <div class="row g-io-form">
            <div class="col-3">
                <slot name="headline">
                    <h5
                        v-if="headline"
                        v-html="headline"
                    ></h5>
                </slot>
                <slot name="left"></slot>
            </div>
            <div class="content" :class="hasSlotSide ? 'col-5' : 'col-9'">
                <slot></slot>
            </div>
            <div v-if="hasSlotSide" class="col-4">
                <slot name="side"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'BaseCardTabs',

  props: {
    headline: {
      type: String,
      required: false,
    },
  },

  computed: {
    hasSlotSide() {
      return !!this.$slots.side;
    },
  },
};
</script>

<style lang="scss">
    .base-input-section {
        border-top: 1px solid #DBDBDB;

        h5 {
            font-size: 20px;
            font-weight: 400;
            margin: 0;
        }

        .content {
            max-width: 700px;
        }
    }
</style>
